// extracted by mini-css-extract-plugin
export var header = "_fr-0";